import { render, staticRenderFns } from "./CustomSyncBlock.vue?vue&type=template&id=022a340f&scoped=true"
import script from "./CustomSyncBlock.vue?vue&type=script&lang=js"
export * from "./CustomSyncBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022a340f",
  null
  
)

export default component.exports